import routeHelper from 'src/routes/helper';

export const START_ROUTES = [routeHelper.additionalClaimWelcome.href()];

export const ACCOUNT_ROUTES = [
  routeHelper.createAccount.href(),
  routeHelper.resetEmail.href(),
  routeHelper.verifiedEmail.href(),
];

export const PROFILE_ROUTES = [
  routeHelper.mapProfiles.href(),
  routeHelper.selectPersonalProfile.href(),
  routeHelper.artistIdentification.href(),
  routeHelper.personalProfile.href(),
  routeHelper.foundProfiles.href(),
];
export const CLAIM_FINISH_ROUTES = ['/claim-success'];

export const ROUTES_WITH_STEPPER = [...START_ROUTES, ...ACCOUNT_ROUTES, ...PROFILE_ROUTES, ...CLAIM_FINISH_ROUTES];

export const STEPPER_NAMES = {
  START: 'Start',
  ACCOUNT: 'Account',
  PROFILE: 'Profiles',
  FINISH: 'Finish',
};
